module.exports = __webpack_public_path__ + "static/img/privacy-policy-300x300.81b930dd.gif";